export default __webpack_public_path__ + "files/34c82b247a366d047105491d979556bf.png";